export interface IPosology {
	ocorrenciaNo: number;
	codigo: any;
	titulo: any;
	habilitado: boolean;
}
